import React from 'react';
import Skeleton from 'wsm-skeleton';
import PropTypes from 'prop-types';

export const MediaSkeletonContainerClasses = ['m-0'];

const MediaSkeleton = React.memo(
	({ placeholderImage, enableFirstSkeletonImg }) => {
		// enableFirstSkeletonImg only can be true when SSR is enabled
		const placeholderImageSrc = enableFirstSkeletonImg
			? 'https://static.dealer.com/images/blank.gif'
			: placeholderImage;
		return (
			<Skeleton
				skeletonClasses="mb-4"
				aspectRatio="4by3"
				placeholderImage={placeholderImageSrc}
				dataTestId="media-skeleton"
			/>
		);
	}
);

MediaSkeleton.propTypes = {
	placeholderImage: PropTypes.oneOfType([PropTypes.string, null]),
	enableFirstSkeletonImg: PropTypes.bool
};

MediaSkeleton.defaultProps = {
	placeholderImage: null
};

export default MediaSkeleton;
